import { create } from 'asciinema-player';
import http_server_cast from './http_server-rev00.cast';
import jumps_cast from './jumps-rev00.cast';

create('/' + jumps_cast,
       document.getElementById('demo-jump'),
       {loop: true }
      );

create('/' + http_server_cast,
       document.getElementById('demo-http'),
       {loop: true }
      );
